import styles from './index.module.less'
import { LeftOutlined } from '@ant-design/icons'
import { Row, Col, Form, Input, Button, ConfigProvider, message } from 'antd'
import { useCountDown, useDebounceEffect, useSetState } from 'ahooks'
import animationQueue, { AnimateView, VIEW_POSITION } from './modules/animationQueueControl'
import classNames from 'classnames'
import PasswordInput from '@/components/PasswordInput'
import OkButton from '@/pages/login/modules/OkButton'
import { foundPassword, sendVerificationCode } from '@/services'
import useValidate from '@/hooks/useValidate.ts'
import { bodyEncrypt } from '@/hooks/useUser.ts'
import {
  tenantResetPassword,
  tenantResetPasswordWithCheckCode,
  tenantResetPasswordWithSendCode,
} from '@/services/user.ts'

const LoginResetPassword = props => {
  // const { onBackAccount } = props

  const { formData } = props
  const [state, setState] = useSetState({
    sendCodeLoading: false,
    step1Loading: false,
    step2Loading: false,
    targetDate: 0,
  })

  const RESET_STEP1_ID = 'reset_step1'
  const RESET_STEP2_ID = 'reset_step2'

  const [step1Form] = Form.useForm()
  const [step2Form] = Form.useForm()

  const [countdown] = useCountDown({
    targetDate: state.targetDate,
    onEnd: () => {
      // alert('End of the time')
    },
  })

  const [validateHelper] = useValidate()

  useDebounceEffect(
    () => {
      // console.log('reset_step1', RESET_STEP1_ID)
      const ids = [RESET_STEP1_ID, RESET_STEP2_ID]
      const baseIndex = 1
      ids.forEach((itemId, i) => {
        animationQueue.insert(
          new AnimateView({ id: itemId, position: VIEW_POSITION.hide }),
          baseIndex + i
        )
      })
    },
    [],
    { wait: 200 }
  )

  useDebounceEffect(
    () => {
      if (formData) {
        step1Form.setFieldsValue(formData)
      } else {
        step1Form.resetFields()
      }
    },
    [formData],
    { wait: 200 }
  )

  const step1BackAccount = () => {
    // viewQueue.slideBack(RESET_STEP1_ID)
    // viewQueue.slideIn('account_form')
    animationQueue.prev()
  }

  const step2BackAccount = () => {
    // viewQueue.slideBack(RESET_STEP2_ID)
    // viewQueue.slideBack(RESET_STEP1_ID, 0)
    // viewQueue.slideIn('account_form')
    // animationQueue.jumpStart()
    animationQueue.prev()
  }
  const handleFinishStep1 = () => {
    step1Form.validateFields().then(values => {
      tenantResetPasswordWithCheckCode(values).then(token => {
        step2Form.resetFields()
        step2Form.setFieldValue('token', token)
        animationQueue.next()
      })
    })
  }

  const handleSendCode = () => {
    step1Form.validateFields(['userName', 'phone']).then(values => {
      setState({ sendCodeLoading: true })
      tenantResetPasswordWithSendCode(values)
        .then(() => {
          setState({ targetDate: Date.now() + 60000 })
        })
        .catch(err => {
          console.log('err', err)
        })
        .finally(() => {
          setState({ sendCodeLoading: false })
        })
    })
  }

  const handleFinishStep2 = () => {
    step2Form.validateFields().then(values => {
      const { password } = values
      setState({ step2Loading: true })

      tenantResetPassword({ ...values, password: password.trim() })
        .then((res: any) => {
          if (res?.message) {
            message.success(res.message)
          }
          step1Form.resetFields()
          step2Form.resetFields()
          props.onSetFormData?.({
            password: password.trim(),
            workNumber: step1Form.getFieldValue('userName'),
          })
          animationQueue.jumpStart()
        })
        .finally(() => {
          setState({ step2Loading: false })
        })
    })
  }

  const triggerPhoneValidate = () => {
    step1Form.validateFields(['phone'])
  }

  return (
    <>
      <div className={classNames(styles.floatView)} id={RESET_STEP1_ID}>
        <PanelTitle title="找回密码" onBack={step1BackAccount} className={styles.mb32} />

        <Form layout="vertical" form={step1Form} onFinish={handleFinishStep1}>
          <div className={styles.inputLabel}>账号</div>
          <Form.Item
            name="userName"
            className={styles.formItem}
            rules={[{ required: true, message: '请输入您的账号' }]}
          >
            <Input className={styles.formInput} variant="borderless" placeholder="请输入您的账号" />
          </Form.Item>

          <div className={styles.inputLabel}>手机号</div>
          <Form.Item
            name="phone"
            className={styles.formItem}
            rules={[validateHelper.phoneValidate]}
          >
            <Input
              className={styles.formInput}
              placeholder="请输入您的手机号"
              onBlur={triggerPhoneValidate}
              variant="borderless"
            />
          </Form.Item>

          <div className={styles.inputLabel}>验证码</div>
          <Row gutter={12}>
            <Col span={15}>
              <Form.Item
                name="code"
                className={styles.formItem}
                rules={[{ required: true, message: '请输入验证码' }]}
                style={{ marginBottom: 0 }}
              >
                <Input
                  className={styles.formInput}
                  variant="borderless"
                  placeholder="请输入验证码"
                />
              </Form.Item>
            </Col>
            <Col span={9}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultBg: '#f1f1f1',
                    },
                  },
                }}
              >
                <Button
                  style={{ height: 48, border: 0 }}
                  block
                  onClick={handleSendCode}
                  disabled={countdown !== 0}
                  loading={state.sendCodeLoading}
                >
                  {countdown === 0 ? '获取验证码' : `${Math.round(countdown / 1000)}s`}
                </Button>
              </ConfigProvider>
            </Col>
          </Row>

          <Form.Item>
            <OkButton loading={state.step1Loading}>确定</OkButton>
          </Form.Item>
        </Form>
      </div>
      <div className={classNames(styles.floatView)} id={RESET_STEP2_ID}>
        <PanelTitle
          title="验证成功，请重置密码并妥善保管"
          onBack={step2BackAccount}
          className={styles.mb60}
        />
        <Form layout="vertical" form={step2Form} onFinish={handleFinishStep2}>
          <Form.Item name="token" hidden={true}>
            <Input variant="borderless" />
          </Form.Item>
          <div className={styles.inputLabel}>新密码</div>
          <Form.Item
            name="password"
            required
            rules={[validateHelper.password('repeatPassword')]}
            className={styles.formItem}
          >
            <PasswordInput
              className={styles.formInput}
              variant="borderless"
              placeholder="请输入您的新密码"
            />
          </Form.Item>
          <div className={styles.inputLabel}>确认密码</div>
          <Form.Item
            name="repeatPassword"
            required
            rules={[validateHelper.password('password', { message: '请确认您的新密码' })]}
            className={styles.formItem}
            style={{ marginBottom: 0 }}
          >
            <PasswordInput
              className={styles.formInput}
              variant="borderless"
              placeholder="请确认您的新密码"
            />
          </Form.Item>

          <OkButton loading={state.step2Loading}>完成</OkButton>
        </Form>
      </div>
    </>
  )
}

export const PanelTitle = props => {
  const { onBack, title, className } = props
  return (
    <div className={classNames(styles.panelTitle, className)} onClick={onBack}>
      <Row align="middle" gutter={8}>
        <Col>
          <LeftOutlined style={{ color: '#888', fontSize: 20 }} />
        </Col>
        <Col style={{ fontSize: 16 }}>{title}</Col>
      </Row>
    </div>
  )
}
export default LoginResetPassword
